import { Transition } from "../../../core/flows/Transition";
import { SearchContext } from "../../Common/Search/Context/SearchContext";
import { SelectOfferContext } from "../../TrainOfferPage/SelectOfferFlow/Context/SelectOfferContext";
import { TicketOptionContext } from "../../TrainOfferPage/TicketOptionFlow/Context/TicketOptionContext";
import { MainBookingContext } from "../Context/MainBookingContext";

export class MainBookingTransition extends Transition {
    constructor(entryStep: string, exitSteps: string[]) {
        super(entryStep, exitSteps);
    }

    onExecute(): string[] {
        const context = this.getCtx<MainBookingContext>("MainBookingContext", this.entryStep);                
        
        const searchContext = new SearchContext()
        this.setCtx<SearchContext>("searchContext", searchContext, this.entryStep)

        if (context?.routeTo?.includes("SelectOfferFlow")) {
            const selectOfferContext = new SelectOfferContext();
            this.setCtx<SelectOfferContext>("SelectOfferContext", selectOfferContext, this.entryStep);
        }

        if (context?.routeTo?.includes("TicketOptionFlow")) {
            const ticketOptionContext = new TicketOptionContext();
            this.setCtx<TicketOptionContext>("ticketOptionContext", ticketOptionContext, this.entryStep);
        }

        if (!context) {
            console.log("[Transition] No choice data available, using default exits");
            return this.exitSteps;
        }

        if (!(context.routeTo ?? []).every(step => this.exitSteps.includes(step))) {
            console.log(`[Transition] Invalid choice: ${context.routeTo}`);
            return [];
        }
        return [...(context?.routeTo ?? [])]
    }

}
